import { useState, useEffect, useMemo } from "react";
import "./Skills.css";
import SkillItem from "./SkillItem";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { authFetch } from "../../helpers";

const FilterSkills = (Props) => {
        const [searchTerm, setSearchTerm] = useState('');
        const [skillItems, setSkillItems] = useState([]);
        const [formItems, setFormItems] = useState([]);
        const [selectedItems, setselectedItems] = useState([]);
        const [searchFocused, setSearchFocused] = useState(false);

        // const { user, isLoading, setUser } = useAuthContext();

        useEffect(() => {
            authFetch(`${API}/skills?sort=order_id&populate=*`)
              .then((resSkill) => {
                return resSkill.json();
              })
              .then((dataSkills) => {
                console.log(dataSkills.data)
                const allItems = dataSkills.data.map((item=>{
                    return item.attributes.skill_types.data
                }))
                setSkillItems(dataSkills.data);
                let catIndex=0;
                let tempCat=[]
                allItems.map((item, index)=>{
                    if(item.length > 0){
                    item.map((catItem)=>{
                        // return catItem.attributes.Category;
                        tempCat[catIndex] = catItem.attributes.Category;
                        catIndex++;
                     })     
                    }
                    
                })
                // console.log(tempCat);
                
                setFormItems(tempCat);
                setselectedItems(tempCat);

                
              })
              .catch((err) => console.error("Error fetching skills:", err));
          }, []);
          console.log("skill:" + skillItems);

        const onchangeSkills = (event)=>{
            setSearchTerm(event.target.value);
          }

        const handleSearchSubmit = (event) => {
            event.preventDefault(); 
        }

        const filteredItems = useMemo(() => {
            if (searchTerm.trim() === '') {
            return skillItems;
            }

            const lowercasedSearchTerm = searchTerm.toLowerCase().trim();

            return skillItems.filter((item) => {
                if (!item || !item.attributes || !item.attributes.Title) {
                    return false; // Skip malformed items
                }
                return item.attributes.Title.toLowerCase().includes(lowercasedSearchTerm);
            });
        }, [searchTerm, skillItems]);

        // console.log("fitered:" + filteredItems[0].attributes.Title);
        console.log("search term:" + searchTerm );

    return(
        <div className="skills filter">
                <div className="head-title mt---10 mb---20">
                    <span>Activities</span>
                    <span className="filter">
                        <form onSubmit={handleSearchSubmit}>
                            <div className={`search-wrap ${searchFocused ? 'expanded' : ''}`}>
                                <input
                                    type="text"
                                    placeholder="Search skill name..."
                                    value={searchTerm}
                                    onChange={onchangeSkills}
                                    onFocus={() => setSearchFocused(true)}
                                    onBlur={() => setSearchFocused(false)}
                                />
                            </div>
                        </form>
                    </span>
                </div>
                <div className="skills-inner">
                    {filteredItems.map((item, i) => { 
                        return (
                            <SkillItem 
                                key={item.id || i} 
                                SklItem={item.attributes} 
                                itemId={item.id}
                            />
                        );
                    })}

                    {filteredItems.length === 0 && searchTerm.trim() !== '' && (
                        <p>No items found matching "{searchTerm}".</p>
                    )}

                </div>
            </div>
    );
}
export default FilterSkills;